import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Button from 'app/components/Button'
import { showErrorToast, showSuccessToast } from 'app/components/ShowToast'

interface ReviewConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  id: string
  onSubmit: (note: string, action: 'approve' | 'deny') => void
  action: 'approve' | 'deny'
}

const ReviewConfirmationModal: React.FC<ReviewConfirmationModalProps> = ({
  isOpen,
  onClose,
  id,
  onSubmit,
  action,
}) => {
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [noteInput, setNoteInput] = useState('')

  useEffect(() => {
    setShowModal(isOpen)
  }, [isOpen])

  const handleClose = () => {
    setShowModal(false)
    setNoteInput('')
    onClose()
  }

  const handleSubmit = async () => {
    if (!noteInput.trim()) {
      showErrorToast({ message: 'Please provide a justification for your action.' })
      return
    }

    try {
      setIsLoading(true)
      onSubmit(noteInput.trim(), action)
      handleClose()
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  return (
    <Modal show={showModal} onHide={handleClose} backdropClassName='bg-opacity-1' centered>
      <Modal.Header style={{ padding: '20px' }}>
        <Modal.Title>{action === 'approve' ? 'Approve' : 'Deny'} Own Review</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '20px' }}>
        <div className='fs-6' style={{ color: '#5A5A5A' }}>
          As a security best practice, individuals should avoid reviewing their own access.
          <br />
          <br />
          However, we understand there may be valid and exceptional circumstances. If you choose to
          proceed, please provide a documented justification for {action === 'approve' ? 'approving' : 'denying'} your own account access.
        </div>

        <div className='mt-4'>
          <label className='fw-semibold fs-6 mb-2 text-gray-900'>Reason</label>
          <textarea
            className='form-control mb-2'
            placeholder='Because...'
            name='notes'
            value={noteInput}
            onChange={(e) => setNoteInput(e.target.value)}
            rows={5}
            style={{ maxHeight: '200px', overflowY: 'auto' }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className='p-0 px-6 py-4 gap-2'>
        <Button onClick={handleClose}>Cancel</Button>
        <Button btnType='primary' onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? (
            <>
              Confirming... <span className='spinner-border spinner-border-sm align-middle'></span>
            </>
          ) : (
            'Confirm'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ReviewConfirmationModal